import React from 'react';
import { string } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import DiscoverIdeasMakeYourLogo from '../../../shared/components/LandingPages/DiscoverIdeasMakeYourLogo';
import IdeaTags from '../../../shared/components/LandingPages/IdeaTags';
import Footer from '../../../shared/components/LandingPages/Footer';
import DiscoverHero from '../../../shared/components/LandingPages/DiscoverHero';
import DesignsByIndustry from '../../../shared/components/LandingPages/DesignsByIndustry';
import { useEffectOnce } from '../../../shared/hooks';
import Breadcrumbs from '../../../shared/components/Breadcrumbs';
import MakeMyLogoButton from '../../../shared/components/MakeMyLogoButton';
import { getBreadcrumbList } from '../../../shared/lib';
import monitor from '../../../service/bigquery';
import GetInspired from './GetInspired';
import {
    POPULAR_KEYWORDS,
    HERO_IMG_URL,
    DESIGNS_BY_INDUSTRY,
    IDEAS_HUB_ACTIONS,
    IDEAS_HUB_SECTIONS,
} from './constants';
import './style.scss';

const { reportPageView, reportIdeasHubBtnClicked } = makersExperience.discoverLogoIdeas;

const DiscoverLogoIdeas = ({ refCtxId }) => {
    useEffectOnce(() => {
        monitor.trackPageView();
        reportPageView();
    });

    const onHeroCTAClick = () =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.START_BRIEF,
            section: IDEAS_HUB_SECTIONS.HEADER_CTA,
        });

    const onMakeYourLogoStartClick = () =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.START_BRIEF,
            section: IDEAS_HUB_SECTIONS.MAKE_YOUR_LOGO,
        });

    const onIdeaTagClick = ({ tagId }) =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.TAG_CLICKED,
            section: IDEAS_HUB_SECTIONS.POPULAR_KEYWORDS,
            tag: tagId,
        });

    const onFooterGetStartedClick = () =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.START_BRIEF,
            section: IDEAS_HUB_SECTIONS.FOOTER,
        });

    const onDesingsTileClick = (title) =>
        reportIdeasHubBtnClicked({
            actionType: IDEAS_HUB_ACTIONS.TAG_CLICKED,
            section: IDEAS_HUB_SECTIONS.INDUSTRIES,
            tag: title,
        });

    const breadcrumbsParams = {
        list: getBreadcrumbList({}),
        theme: Breadcrumbs.THEMES.DARK,
    };

    return (
        <div className="discover-logo-ideas">
            <MakeMyLogoButton />
            <DiscoverHero
                breadcrumbsParams={breadcrumbsParams}
                heroImageUrl={HERO_IMG_URL}
                titlePrefix="logo_maker_perseus.discover_logo_ideas.hero.title"
                descriptionPrefix="logo_maker_perseus.discover_logo_ideas.hero.get_inspired"
                additionalDescriptionPrefix="logo_maker_perseus.discover_logo_ideas.hero.looking_for_logo"
                onMakeYourLogoClick={onHeroCTAClick}
            />
            <DesignsByIndustry
                titlePrefix="logo_maker_perseus.discover_logo_ideas.logo_by_industry.title"
                industriesPrefix="logo_maker_perseus.discover_logo_ideas.logo_by_industry.industries"
                desingsTiles={DESIGNS_BY_INDUSTRY}
                onTileClick={onDesingsTileClick}
            />
            <DiscoverIdeasMakeYourLogo onStartClick={onMakeYourLogoStartClick} />
            <GetInspired />
            <IdeaTags
                onClick={onIdeaTagClick}
                tags={POPULAR_KEYWORDS}
                title={<I18n k="logo_maker_perseus.discover_logo_ideas.popular_keywords.title" />}
                refCtxId={refCtxId}
            />
            <Footer
                onSubmit={onFooterGetStartedClick}
                footerTitle={<I18n k="logo_maker_perseus.discover_logo_ideas.footer.title" />}
            />
        </div>
    );
};

DiscoverLogoIdeas.propTypes = {
    refCtxId: string,
};

export default DiscoverLogoIdeas;
